"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ERROR_INVALID_CREDENTIALS_message: 'Invalid email or password. Please Try Again',
    ERROR_INVALID_CREDENTIALS_title: 'Invalid Credentials',
    ERROR_UNEXPECTED_message: 'Sorry, an unexpected error occurred while processing your request. Please try again, or contact your administrator if the issue persists.',
    ERROR_UNEXPECTED_title: 'Unexpected Error',
    ERROR_USER_DEACTIVATED_message: 'Your account has been deactivated. Please try again, or contact your administrator if the issue persists.',
    ERROR_USER_DEACTIVATED_title: 'User Deactivated',
    passwordInputLabel: 'Password',
    resetPasswordLinkLabel: 'Reset Password',
    submitButtonLabel: 'SIGN IN',
    orLabel: 'OR',
    title: 'Sign In',
    usernameInputLabel: 'Email Address'
};
